import { SVGProps } from 'react';

const SvgEmbed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.9 10.6 3.3 6l4.6-4.6L6.5 0l-6 6 6 6 1.4-1.4Zm5.2 0L17.7 6l-4.6-4.6L14.5 0l6 6-6 6-1.4-1.4Z" />
  </svg>
);

export default SvgEmbed;
